/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import { Reducer } from "redux";
import *as actionsTypesFromStore from '@apps-store/@types';
import { ReducersInterface } from '@apps-store/models';
import * as actions from '@apps-store/enums';

/**
 * @function StatsReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeStatsAction } action: action de l'application
 * @return { Reducer }
 */
export const StatsReducer: Reducer< ReducersInterface<any>> = ( state: any = {
   
} , action: actionsTypesFromStore.TypeStatsAction) => {
    
    switch (action.type) {

        case actions.StatsTypes.STATS_INPROGRESS:

            return {

                loading: true,
                ...state

            }
            
            break;
        case actions.StatsTypes.STATS_FAIL:

            return {

                error: action.payload.error ,
                loading: false,
                
            }
            
            break;
        
        case actions.StatsTypes.STATS_SUCCESS:

            return {

                data: action.payload.data ,
                loading: false,
                
            }
            
            break;
    
        default:
            return state
            break;
    }
    
}


// WEBPACK FOOTER //
// ./src/apps/store/reducers/stats/index.ts